import { Component, inject } from '@angular/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { IsVisibleDirective } from 'src/app/directives/is-visible.directive';
import { ContentService } from 'src/app/services/content.service';
import { CorrectImageUrlPipe } from '../../correct-image-url.pipe';
import { SplitRolesPipe } from '../../split-roles.pipe';
import { MarkdownComponent } from '../markdown/markdown.component';

@Component({
  selector: 'app-mitglieder',
  templateUrl: './mitglieder.component.html',
  styleUrls: ['./mitglieder.component.scss'],
  imports: [
    LazyLoadImageModule,
    MarkdownComponent,
    SplitRolesPipe,
    CorrectImageUrlPipe,
    IsVisibleDirective,
  ],
})
export class MitgliederComponent {
  #content = inject(ContentService);
  mitglieder = this.#content.currentMembers;
  ehemaligeMitglieder = this.#content.formerMembers;
}
